/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable jsx-a11y/alt-text */
/* eslint-disable react/jsx-no-comment-textnodes */
import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import FontFa from "../fontFa/fontFa";
// import { CreateNotification } from "../notifier";
import "./bubble-chat.scss";
import Draggable from "react-draggable";

export const BubbleChat = () => {
  // const history = useHistory();
  const [isHidden, setIsHidden] = useState(() => {
    return localStorage.getItem("bubbleChatHidden") === "true";
  });
  const location = useLocation();

  // Ẩn ở môi trường dev và UAT, chỉ hiển thị ở production
  const environment = process.env["REACT_APP_ENV"];
  const isProduction = environment === "production";

  // const onChatClick = () => {
  //   setIsHidden(true);
  //   localStorage.setItem("bubbleChatHidden", "true");
  //   history.push("/chats");
  //   // CreateNotification({
  //   //   title: "Thông báo",
  //   //   body: `Tính năng đang được thực hiện, sẽ triển khai cho anh/chị trong thời gian sớm nhất. Xin cảm ơn !`,
  //   //   icon: "/icons/warning.png",
  //   // });
  // };

  useEffect(() => {
    if (location.pathname === "/chats") {
      setIsHidden(true);
      localStorage.setItem("bubbleChatHidden", "true");
    } else {
      setIsHidden(false);
      localStorage.removeItem("bubbleChatHidden");
    }
  }, [location.pathname]);

  // Không hiển thị nếu không phải môi trường production hoặc đã ẩn
  if (!isProduction || isHidden) return null;
  return (
    <Draggable>
      <div className="bubble-chat" style={{ cursor: "pointer" }}>
        <div className="bubble-float" id="menu-share" title="Thông tin liên hệ">
          <FontFa name="faHeadset" className="my-float mt-3" />
          <p className="menu-text">IT Helpdesk</p>
        </div>
        <ul>
          <li>
            <a href="mailto: it@viags.vn" id="menu-google-plus" title="Gửi email" target="_blank" rel="noreferrer">
              <FontFa name="faMailBulk" className="my-float" />
            </a>
          </li>
          <li>
            <a href="tel:0909038845" id="menu-facebook" title="Gọi điện thoại" target="_blank" rel="noreferrer">
              <FontFa name="faPhone" className="my-float" />
            </a>
          </li>
        </ul>
      </div>
    </Draggable>
  );
};
